import { Mail, Phone, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

export default function Contact() {
  return (
    <div data-testid="contact-page" className="bg-white">
      <section className="bg-navy text-white py-20 lg:py-28">
        <div className="container-narrow">
          <div className="overline text-gold mb-4">Contact</div>
          <h1 className="text-4xl sm:text-6xl font-display font-semibold leading-[1.05] max-w-4xl">
            Let's get on a call.
          </h1>
          <p className="mt-6 max-w-2xl text-lg text-gray-300">
            For circle visits, franchise opportunities or partnerships,
            here's how to reach the right person fast.
          </p>
        </div>
      </section>

      <section className="py-24">
        <div className="container-narrow grid md:grid-cols-3 gap-6">
          {[
            { icon: Mail, label: "Email", value: "mayuri@franglobal.com", href: "mailto:mayuri@franglobal.com" },
            { icon: Phone, label: "Phone", value: "+91 98114 78372", href: "tel:+919811478372" },
            { icon: MapPin, label: "Cities", value: "Chandigarh Tricity · Ahmedabad · Delhi-NCR · more soon" },
          ].map((c) => (
            <div key={c.label} className="border border-gray-200 rounded-2xl p-8 hover:border-gold/50 transition">
              <c.icon size={20} className="text-gold" />
              <div className="overline text-navy/60 mt-5">{c.label}</div>
              {c.href ? (
                <a href={c.href} className="mt-1 block font-display text-lg text-navy hover:text-gold transition">
                  {c.value}
                </a>
              ) : (
                <div className="mt-1 font-display text-lg text-navy">{c.value}</div>
              )}
            </div>
          ))}
        </div>

        <div className="container-narrow mt-16">
          <div className="bg-cream rounded-3xl p-10 lg:p-16 text-center">
            <h3 className="text-3xl sm:text-4xl font-display font-semibold text-navy">
              Pick a path:
            </h3>
            <div className="mt-8 flex flex-wrap justify-center gap-4">
              <Link
                to="/visit-a-circle"
                className="inline-flex items-center bg-navy text-white px-7 py-4 rounded-full font-semibold hover:-translate-y-0.5 transition"
              >
                Visit a Circle
              </Link>
              <Link
                to="/franchise"
                className="inline-flex items-center bg-gold text-white px-7 py-4 rounded-full font-semibold hover:-translate-y-0.5 transition"
              >
                Become a Franchisee
              </Link>
              <Link
                to="/our-circles"
                className="inline-flex items-center border border-navy text-navy px-7 py-4 rounded-full font-semibold hover:bg-navy hover:text-white transition"
              >
                Browse Members
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
